export type IOrderItem = Order;

export interface OrderFilterState {
  types: string[];
}

export enum Entity {
  USER,
  MERCHANT,
}

export enum DisputeStatus {
  RAISED,
  SETTLED,
}

export interface Dispute {
  raisedBy: Entity;
  status: DisputeStatus;
  redactTransId: number;
  accountNumber: number;
}

export enum OrderStatus {
  PLACED,
  ACCEPTED,
  PAID,
  COMPLETED,
  CANCELLED,
}

export enum OrderType {
  BUY,
  SELL,
}

export interface Order {
  amount: string;
  fiatAmount: string;
  placedTimestamp: string;
  completedTimestamp: string;
  userCompletedTimestamp: string;
  assignedMerchants: string[];
  acceptedMerchant: string;
  user: string;
  recipientAddr: string;
  pubkey: string;
  encUpi: string;
  userCompleted: boolean;
  status: OrderStatus;
  orderType: OrderType;
  disputeInfo: Dispute;
  id: string;
}
